import React from 'react';
import {Skeleton, Stack} from '@mui/material';
import {SKELETONS} from './constants';

export default function LoadingSkeleton() {
	return (
		<Stack spacing={3}>
			{SKELETONS.map((skeleton, index) => (
				<Skeleton
					key={index}
					variant="rounded"
					width={skeleton.width}
					height={skeleton.height}
				/>
			))}
		</Stack>
	);
}
